<template>
  <main class="patient-layout">
    <router-view></router-view>
  </main>
</template>

<script>
/**
 * Component Patient.vue
 *
 * @module Patient
 * @date
 * @author
 * @copyright UniWeb bvba 2022
 *
 * @link https://gitlab.uniweb.be/cor/4.04-caregiver-dashboard
 *
 * @coropreventionSW [SW-4.3] app/src/APP_DASHBOARD/templates/layout/Patient.vue
 * @see https://docs.google.com/document/d/1iOpHH151s_ABr-DniJIc__q-GHpXJJVq/edit#heading=h.a0z8d9xd3xr7
 *
 */

export default {
  name: 'Patient',
  computed: {
    isRecordOpened() {
      return this.$store.getters['followupSession/isRecordOpened'];
    }
  },
  beforeRouteLeave(to, from, next) {
    const pages = ['Settings', 'About', 'FAQ', 'Help']
    // Reset for all routes except main menu pages with back button ( if record is opened )
    if (!this.isRecordOpened || !pages.includes(to.name)) {
      this.$store.dispatch('patientSummary/requireReset');
      this.$store.dispatch('patientList/requireReset');
    }

    next();
  },
};
</script>

<style lang="scss">
.patient-layout {
  flex-grow: 1;
  display: flex;
  flex-direction: column;
}
</style>
